/**
 * Whether card pricing should be shown for a profile.
 *
 * Two flags were involved and only one of them was ever a gate.
 *
 * `pricing_trigger` was an eligibility flag whose rules were never settled. It
 * defaulted to false, so it hid pricing from 46 of 51 profiles, and it was
 * removed here in the 2026-08-17 walkthrough - but CardDetail, FairTrade and
 * Preferences each kept their own copy of the old two-flag test, so the app was
 * running three different rules and pricing appeared or vanished depending on
 * which screen you were standing on. Those call sites go through this function
 * now, and nothing reads the trigger.
 *
 * `pricing_enabled` stays, because it is not a gate - it is the owner's own
 * "hide prices" switch in Preferences. It defaults to true now, so pricing is
 * on out of the box and someone who does not want to see it can still turn it
 * off.
 */
export const isPricingVisible = (profile) => profile?.pricing_enabled !== false;
